<template>
  <k-video-grid :items="system ? system_channels : developer ? developer_channels : filtered_channels" :storage-key="system ? 'monitor-system' : developer ? 'monitor-developer' : 'monitor'" :max-entries="1000">
    <template #default="{ item }">
      <item :data="item" :developer="developer"></item>
    </template>
  </k-video-grid>
</template>

<script>
import ChannelModel from '@/models/channel.js';
import InstanceModel from '@/models/instance.js';
import Item from './Item'
import naturalSort from 'natural-sort'

export default {
  props: ['system', 'developer'],
  components: {
    Item
  },
  data () {
    return {
      naturalSort: naturalSort(),
      ready: false
    }
  },
  computed: {
    monitor_filters () {
      return this.$store.state.account.meta.monitor_channel_filter ||[];
    },
    instances() {
      return this.$store.state.instances;
    },
    developer_channels () {
      return _.filter(this.channels, (channel) => {
        var instance = ChannelModel.instance(channel.channel, null);
        return _.get(instance, "meta.is_developer", false);
      }).sort((a,b) => {
        var aTitle = _.get(a, "channel.title", "");
        var bTitle = _.get(b, "channel.title", "");
        return this.naturalSort(aTitle, bTitle);
      });
    },
    system_channels () {
      return _.filter(this.channels, (channel) => { return this.monitor_filters.includes(channel.key) && _.get(channel, "channel.meta.system_channel", false); }).sort((a,b) => {
        var aTitle = _.get(a, "channel.title", "");
        var bTitle = _.get(b, "channel.title", "");
        return this.naturalSort(aTitle, bTitle);
      });
    },
    filtered_channels () {
      return _.filter(this.channels, (channel) => { 
        if(!this.monitor_filters.includes(channel.key)) return false;
        var instance = ChannelModel.instance(channel.channel, null);
        if (_.get(instance, "meta.is_developer", false) == true) return false;
        return !_.get(channel, "channel.meta.system_channel", false); 
      }).sort((a,b) => {
        var aTitle = _.get(a, "channel.title", "");
        var bTitle = _.get(b, "channel.title", "");
        return this.naturalSort(aTitle, bTitle);
      });
    },
    channels () {
			var st = ChannelModel.status_all();
			if (typeof(st) != "undefined") {
				var res = [];
        _.each(st, (data, id) => {
          var headend = this.instances[data.headend_instance];
          var state = (this.get_source_state(data)||{}).state;
          if (typeof(headend) != "undefined") {
            var uuid = id.split(":")[0];
            var alternative = id.split(":")[1] || "";
            var channel = ChannelModel.channel_by_uuid(uuid);
            if(channel) res.push({uuid: id, key: id, state: state, channel: channel, alternative: alternative, url: InstanceModel.headend_preview_url(headend, uuid, alternative)});
          }
        });
        return res;
			}
			return [];
		}
  },
  methods: {
    get_state(data, type) {
			var i = data.instance;
			if (typeof(i) != "undefined") {
				var s = i[type];
				if (typeof(s) != "undefined") {
					return s;
				}
			}
			return;
		},

		get_source_state(data) {
			return this.get_state(data, "source");
		}
  },
  mounted() {
    this.$store.dispatch("get_profile").then(() => {
      this.$nextTick(() => {
        this.ready = true;
      });
    }, () => {});
  }
}
</script>
